import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { View } from 'react-native';
import { WeeklyPurchaseQuantity } from '@sales-portal/domain/pricing/screens/management/blocs/transformers/use-pricing-management-transformers';

interface WeeklyPurchaseQuantitiesCellProps {
  quantities: WeeklyPurchaseQuantity[] | undefined;
}

interface PurchaseQuantityBar {
  key: string;
  quantity: number;
}

const BAR_HEIGHT_MAX = 18;
const BAR_HEIGHT_MIN_NONZERO = 5;
const ZERO_HEIGHT = 2;
const BAR_WIDTH = 5;
const BAR_GAP = 4;
const ZERO_OPACITY = 0.5;
const PLACEHOLDER_WEEKS = 6;

export const WeeklyPurchaseQuantitiesCell: React.FC<
  WeeklyPurchaseQuantitiesCellProps
> = ({ quantities }) => {
  const [styles] = useStyles();
  // Empty input still renders 6 placeholder slots.
  const weeks: PurchaseQuantityBar[] =
    quantities && quantities.length > 0
      ? quantities.map((w) => ({ key: w.startDate, quantity: w.quantity }))
      : Array.from({ length: PLACEHOLDER_WEEKS }, (_, i) => ({
          key: `placeholder-${i}`,
          quantity: 0,
        }));
  const max = Math.max(...weeks.map((w) => w.quantity), 0);

  return (
    <View style={styles.container}>
      {weeks.map((week) => {
        const isZero = week.quantity <= 0;
        const height = isZero
          ? ZERO_HEIGHT
          : Math.max(
              BAR_HEIGHT_MIN_NONZERO,
              (week.quantity / max) * BAR_HEIGHT_MAX,
            );
        return (
          <View
            key={week.key}
            style={[styles.bar, { height }, isZero && styles.barZero]}
          />
        );
      })}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  bar: {
    backgroundColor: theme.sk.color.text.tertiary,
    borderRadius: 1,
    width: BAR_WIDTH,
  },
  barZero: {
    opacity: ZERO_OPACITY,
  },
  container: {
    alignItems: 'flex-end',
    flexDirection: 'row',
    gap: BAR_GAP,
    height: BAR_HEIGHT_MAX,
    paddingBottom: 2,
  },
}));
